import { render, staticRenderFns } from "./placeholderList.vue?vue&type=template&id=ccb1a2ee&scoped=true&"
import script from "./placeholderList.vue?vue&type=script&lang=js&"
export * from "./placeholderList.vue?vue&type=script&lang=js&"
import style0 from "./placeholderList.vue?vue&type=style&index=0&id=ccb1a2ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb1a2ee",
  null
  
)

export default component.exports